<script>
  import { blocklist, text, richtext, image, url, exists } from "../toolbox.js";
  import { link, links } from "svelte-routing";

  export let block;
  export let colors = ['#1d54b6', '#1d54b6', '#1d54b6', '#1d54b6']
</script>

<section id="pricing" class="pricing">

  <div class="container" data-aos="fade-up">

    <header class="section-header">
      <h2>{text(block, 'preheadline')}</h2>
      <p>{text(block, 'headline')}</p>
    </header>

    <div class="row justify-content-center pb-5" data-aos="fade-left">

      {#each blocklist(block, 'prices') as item, i}
      <div class="col-lg-3 col-md-6" data-aos="zoom-in" data-aos-delay="100">
        <div class="box">
          <h3 style="color: {colors[i%4]}; height: 4em;">{text(item, 'title')}</h3>
          <div class="price">{@html richtext(item, 'price')}</div>
          <img src="{image(item, 'icon', [100, 100])}" class="img-fluid" alt="">
          <p style="height: 5em; overflow: auto;">{@html richtext(item, 'body')}</p>
          {#if exists(item, 'button')}
          <a href="{url(item, 'button')}" class="btn-buy" use:link>{text(item, 'button')}</a>
          {/if}
        </div>
      </div>
      {/each}

    </div>

  </div>

</section>
